export * from './dynamic-multiple-offers-switch-frequency-new-benefits-lock'
